import {
  PatientDetail,
  PatientListResponse,
  PatientState,
  ObstetricEvent,
  ResolutiveEvent
} from './types'

export const state: PatientState = {
  loadingPatient: true,
  loadingPatientsList: true,
  loadingCurrentCondition: false,
  patientsResponse: {} as PatientListResponse,
  patientDetail: {} as PatientDetail,
  patientConsultationsList: [],
  loadingConsultations: true,
  resolutiveEvent: {
    hasClinicalHistories: true,
    hasMorbidityRegistry: false,
    morbidityRegistryId: 0,
    resolutionEventId: 16,
    birthType: '1',
    birthTypeDescription: 'Parto natural',
    date: '2023-06-26 20:44:18.849308',
    status: 1,
    statusDescription: 'Pendiente',
    hospital: 'Hospital Chapalita',
    hospitalKit: 'Kit de hospital'
  } as ResolutiveEvent, //{}
  obstetricEvent: {} as ObstetricEvent,
  morbidityRegistry: [],
  clinicalHistory: [],
  currentCondition: []
}
